export const tokenKey = `paces-admin-token-${process.env.STAGE}`;
export const refreshTokenKey = `paces-admin-refresh-token-${process.env.STAGE}`;
export const accessTokenKey = `paces-admin-access-token-${process.env.STAGE}`;